export default __webpack_public_path__ + "static/media/wholesaledealer.4b899355.webp";